import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ProgressPlayerHelper } from '../../../features/progress-player/progress-player-helper';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import * as _ from "lodash";

@Component({
  selector: 'app-window-progress',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions,MatButtonModule],
  templateUrl: './window-progress.html',
  styleUrl: './window-progress.scss'
})
export class WindowProgress implements OnInit {
  readonly dialogRef = inject(MatDialogRef<WindowProgress>);
  data = inject(MAT_DIALOG_DATA);
  progressHelper = inject(ProgressPlayerHelper);
  countLevel: number = 0;

  ngOnInit(): void {
     this.dialogRef.disableClose = true;
     if(!_.isEmpty(this.progressHelper.allProgress)){
      this.progressHelper.allProgress.forEach(item =>{
        let leng = item.levels.length;
        if(this.countLevel < leng){
          this.countLevel = leng;
        }
      })
     }
  }

  academicPerformance(typeId: number, level: number){
    let rating = ' - ';
    this.progressHelper.findType(typeId);
    if(!_.isEmpty(this.progressHelper.progress)){
      let result: any = this.progressHelper.findLevel(level);
      if( !_.isEmpty(result) ){
        if(result.rating !== 0){
          rating = result.rating;
        }
      }
    }
    return rating;
  }

  onNoClick(){
    this.dialogRef.close();
  }

}
